import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import './index.css';
import setupConsoleFilters from './utils/logFilter';

// Apply console filters to reduce noise in the console
setupConsoleFilters();

// Remove deprecated future flags implementation
// import { UNSAFE_enableFutureFlags } from 'react-router-dom';
// UNSAFE_enableFutureFlags(['v7_startTransition', 'v7_relativeSplatPath']);

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <BrowserRouter future={{
      v7_startTransition: true,
      v7_relativeSplatPath: true
    }}>
      <App />
    </BrowserRouter>
  </React.StrictMode>
); 